import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import {
  HiChartBarSquare,
  HiCreditCard,
  HiGlobeAlt,
  HiHome,
  HiShoppingBag,
} from "react-icons/hi2";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import DashboardSideNavContent from "../components/dashboard/DashboardSideNavContent";

const drawerWidth = 280;
const desktopDrawerWidth = 250;

const listItemData = [
  {
    label: "Dashboard",
    link: "/seller/dashboard",
    icon: HiHome,
    end: true,
  },
  {
    label: "My Listings",
    link: "/seller/my-listings",
    icon: HiChartBarSquare,
  },
  {
    label: "My Shop",
    link: "/seller/my-shop",
    icon: HiShoppingBag,
  },
  {
    label: "Billing Information",
    link: "/seller/billing-information",
    icon: HiCreditCard,
  },
];

function SideNav(props) {
  const { profiledata } = useIndexPageData();
  const { window } = props;

  const renderDrawer = (isMobile) => (
    <DashboardSideNavContent
      title="Seller Hub"
      subtitle="Workspace"
      switchLink={{
        to: "/user/dashboard",
        label: "Go to User Dashboard",
      }}
      navItems={listItemData}
      profiledata={profiledata}
      isMobile={isMobile}
      onClose={props.handleDrawerToggle}
    />
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const drawerPaperStyles = {
    boxSizing: "border-box",
    border: "none",
    bgcolor: "#151821",
    color: "#fff",
    overflow: "hidden",
    zIndex: { md: 900, xs: 1201 },
  };

  return (
    <Box
      component="nav"
      sx={{
        width: { md: desktopDrawerWidth },
        flexShrink: { md: 0 },
      }}
      aria-label="Seller dashboard navigation"
    >
      <Drawer
        container={container}
        variant="temporary"
        open={props.mobileOpen}
        onClose={props.handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            ...drawerPaperStyles,
            width: drawerWidth,
            maxWidth: "88vw",
          },
        }}
      >
        {renderDrawer(true)}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            ...drawerPaperStyles,
            width: desktopDrawerWidth,
          },
        }}
        open
      >
        {renderDrawer(false)}
      </Drawer>
    </Box>
  );
}

SideNav.propTypes = {
  window: PropTypes.func,
  mobileOpen: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
};

export default SideNav;
